import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Row, Col, Spin } from "antd";
import { PageHeader } from "../../../components/page-headers/page-headers";
import { Main, CardToolbox } from "../../styled";

import { Button } from "../../../components/buttons/buttons";
import { GetGraphQlData } from "./dataQueriesPaginated";

import { useTranslation } from "react-i18next";
import { AutoComplete } from "../../../components/autoComplete/autoComplete";
import { PanelFiltrov } from "../../../components/filtre/panelFiltrov";
import { useZdrzanie } from "../../../utils/zdrzanie";

import {
  setAllProducts,
  setTableFiler,
  setTaxes,
} from "../../../redux/products/actionCreator";

import List from "./list";

import { useDispatch, useSelector } from "react-redux";
import NewRecordModal from "./newRecordModal";

const graphqlVariables = {
  tokenGet: process.env.REACT_APP_TOKEN_GET,
  tokenMutation: process.env.REACT_APP_TOKEN_MUTATION,
};

const Products = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const tableData = useSelector((state) => state?.products?.allProducts);
  const listData = useSelector((state) => state?.products?.tableFilter);
  const taxesData = useSelector((state) => state?.products?.taxes);

  const [loadingList, setLoadingList] = useState(true);
  const [total, setTotal] = useState(0);
  const [pageNumberToGrid, setPageNumberToGrid] = useState(1);
  const [limit, setLimit] = useState(20);
  const [searchText, setSearchText] = useState("");
  const hladanyText = useZdrzanie(searchText, 300);
  const PRAZDNE_FILTRE = { typ: undefined, dodavatel: undefined, cena: undefined };
  const [filtre, setFiltre] = useState(PRAZDNE_FILTRE);

  const definicieFiltrov = [
    {
      kluc: "typ",
      popis: "Typ položky",
      typ: "vyber",
      sirka: 6,
      moznosti: [
        { hodnota: "product", popis: "produkt" },
        { hodnota: "service", popis: "služba" },
      ],
    },
    {
      // Vacsina poloziek je z Ayvensu, "vlastné" ukaze ich vlastny cennik.
      kluc: "dodavatel",
      popis: "Dodávateľ",
      typ: "vyber",
      sirka: 6,
      moznosti: [
        { hodnota: "ayvens", popis: "Ayvens" },
        { hodnota: "vlastne", popis: "vlastné položky" },
      ],
    },
    {
      // Polozka s nulovou cenou sa do zakazky dostane zadarmo.
      kluc: "cena",
      popis: "Predajná cena",
      typ: "vyber",
      sirka: 6,
      moznosti: [
        { hodnota: "ma", popis: "vyplnená" },
        { hodnota: "nema", popis: "chýba alebo nula" },
      ],
    },
  ];

  const [gridState, setGridState] = useState({
    addNewRecord: false,
  });

  // Create query variables object that includes pagination + optional search
  const queryVariables = {
    ...graphqlVariables,
    offset: (pageNumberToGrid - 1) * limit,
    limit: limit,
    search: hladanyText || undefined,
    typ: filtre.typ,
    dodavatel: filtre.dodavatel,
    cena: filtre.cena,
  };

  // Fetch data (pattern aligned with /admin/service/actions)
  const graphQlData = GetGraphQlData(queryVariables, true);
  const productsResponse = graphQlData[0]?.data?.getProducts;
  const taxes = graphQlData[1]?.data?.getTaxes;
  const loading = graphQlData[0]?.loading || graphQlData[1]?.loading;
  const error = graphQlData[0]?.error || graphQlData[1]?.error;

  useEffect(() => {
    if (loading) {
      setLoadingList(true);
      return;
    }
    if (error) {
      setLoadingList(false);
      return;
    }

    if (productsResponse && taxes) {
      const items = Array.isArray(productsResponse?.items)
        ? productsResponse.items
        : [];
      setTotal(productsResponse?.totalCount || 0);
      dispatch(setAllProducts(items));
      dispatch(setTableFiler(items));
      dispatch(setTaxes(taxes));
      setLoadingList(false);
    }
  }, [loading, error, productsResponse, taxes, dispatch]);

  // Nastavenie nacitavania tu nie je zamerne: dopyt odchadza az po zdrzani,
  // takze by tabulka zmizla hned pri prvom pismene a ostala prec cely cas
  // pisania. Stav nacitavania riadi odpoved servera.
  const handleSearch = (text) => {
    setSearchText(typeof text === "string" ? text : "");
    setPageNumberToGrid(1);
  };

  const handleChangePage = (data) => {
    setLoadingList(true);
    setPageNumberToGrid(data?.pageNumber);
    setLimit(data?.pageSize);
  };

  const showNewRecordModal = () => {
    setGridState({
      ...gridState,
      addNewRecord: true,
    });
  };
  const onCancel = () => {
    setGridState({
      ...gridState,
      addNewRecord: false,
    });
  };
  const handleCancel = () => {
    onCancel();
  };

  return (
    <>
      <CardToolbox>
        <PageHeader
          ghost
          title={t("backend.products.title")}
          subTitle={
            <>
              <span className="title-counter">{t("carOwners.filter")} </span>
              <AutoComplete
                onSearch={handleSearch}
                // dataSource={notData}
                placeholder={t("carOwners.startWritting")}
                width="100%"
                patterns
              />
            </>
          }
          buttons={[
            <Button
              onClick={showNewRecordModal}
              className="btn-add_new"
              size="default"
              type="primary"
              key="1"
            >
              <Link to="#">{t("common.addRecord")}</Link>
            </Button>,
          ]}
        />
      </CardToolbox>
      <Main>
        <Row gutter={15}>
          <Col md={24}>
            <PanelFiltrov
              filtre={definicieFiltrov}
              hodnoty={filtre}
              onZmena={(kluc, hodnota) => {
                setFiltre((predosle) => ({ ...predosle, [kluc]: hodnota }));
                setPageNumberToGrid(1);
                setLoadingList(true);
              }}
              onVycistit={() => {
                setFiltre(PRAZDNE_FILTRE);
                setPageNumberToGrid(1);
                setLoadingList(true);
              }}
            />
          </Col>
        </Row>
        <Row gutter={15}>
          <Col md={24}>
            {loadingList && (
              <div className="spin">
                <Spin />
              </div>
            )}
            {!loadingList && (
              <List
                inputData={listData}
                graphqlVariables={graphqlVariables}
                taxes={taxesData}
                total={total}
                sendPageNumberToGrid={handleChangePage}
                pageNumberToGrid={pageNumberToGrid}
                limit={limit}
              />
            )}
          </Col>
        </Row>
      </Main>
      <NewRecordModal
        t={t}
        gridState={gridState}
        handleCancel={handleCancel}
        onCancel={onCancel}
        tableData={tableData}
        taxes={taxesData}
      />
    </>
  );
};

export default Products;
